<template >
    <!-- <div> -->
<v-container class="fill-height py-0 hero-content" fluid>
            <v-row no-gutters class="fill-height">

                <!-- Left spacer column -->
                <v-col sm="2" lg="6" class="d-none d-sm-flex"></v-col>

                <v-col>
                    <!-- Content Row -->
                    <v-row class="fill-height d-flex justify-center">
                        <v-col
                        class="d-flex flex-column align-center
                        justify-space-between fill-height py-0"
                        >
                        <!-- Here's what the cols were before: sm="10" lg="8" -->
                            <!-- Logo Row -->
                            <v-row class="d-flex align-center">
                                <!-- <img src="@/assets/Logo.svg"
                                    alt="Microtone Logo"
                                    class="py-0 pl-4 ml-logo"
                                /> -->
                                <mt-logo></mt-logo>
                                <!-- <v-icon color="white" class="mt-logo">MTlogo</v-icon> -->
                                <!-- TODO: Replace image and text with vectorized combo of both -->
                                <span
                                class="white--text
                                pl-2
                                align-self-center"
                                id="microtone-logo-text"
                                >
                                MicroTone Guitars
                                </span>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <p class="text-center mx-5 white--text
                                                text-h5"
                                    >
                            <!-- :class="[$vuetify.breakpoint.xs ? 'display-1' : 'display-1']" -->
                                    <!-- Was: display-1 : display-2 -->
                                        Guitars that sound better than you ever imagined
                                    </p>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <p class="mx-5 font-weight-thin white--text
                                    text-h6"
                                    >
                                    <!-- Was: 'headline' : 'display-1  -->
                                        MicroTone Guitars makes interchangeable fretboards with
                                        precisely located frets to perfectly tune everything you
                                        play.
                                    </p>
                                </v-col>
                            </v-row>

                            <!-- CTA Row -->
                            <v-row>
                                <v-col class="d-flex flex-column justify-center">
                                    <p class="text-center white--text mb-1
                                    text-body-2
                                    text-sm-body-1
                                    text-md-h6">
                                        Get updates on our guitars <br> by joining our mailing list!
                                    </p>
                                    <!-- <v-btn x-large color="accent" v-ripple
                                    class="font-weight-bold mt-0 elevation-24">
                                        Sign Up
                                    </v-btn> -->
                                    <cta-btn />
                                </v-col>
                            </v-row>

                            <!-- Bottom chevron row -->
                            <v-row class="align-content-end mb-2">
                                <v-col class="pa-0">
                                    <v-icon color="white" x-large>
                                        <!-- {{ "mdi-chevron-double-down" }} -->
                                        {{ chevron }}
                                    </v-icon>
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                </v-col>

                <!-- Right spacer column -->
                <v-col md="1" lg="1" class="d-none d-md-flex"></v-col>

            </v-row>


        </v-container>
    <!-- </div> -->
</template>

<script>
import { mdiChevronDoubleDown } from '@mdi/js';

export default {
  data: () => ({
    chevron: mdiChevronDoubleDown,
  }),
};
</script>

<style scoped>
  @font-face {
    font-family: "cinzel";
    src: url("../assets/fonts/Cinzel-Regular.ttf") format("truetype");
    font-display: swap;
  }

  .ctr-button {
      margin: 0 auto;
  }

  .ml-logo {
      width: 60px;
      color: white;
      /* height: 44px; */
  }

    #microtone-logo-text {
        font-family: cinzel, serif;
        font-size: 1rem;
        letter-spacing: 3px;
    }

  @media only screen and (min-width: 600px) {
      /* Breakpoint: sm */
        #microtone-logo-text {
            font-family: cinzel, serif;
            font-size: 1.5rem;
            letter-spacing: 3px;
        }

    }

  @media only screen and (min-width: 960px) {
      /* Breakpoint: md */
        #microtone-logo-text {
            font-family: cinzel, serif;
            font-size: 2rem;
            letter-spacing: 3px;
        }

    }

  .hero-content {
    position: absolute;
    z-index: 2;
    top: 0px;
    height: 100vh;
  }
  /* .fullheight {
      height: 100vh
  } */
</style>
